export default __webpack_public_path__ + "static/SCUBA_Tank-eab9fa320f04e6cd7434737b4c5a2bee.png";